// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2wjMe","inner":"Footer_inner__3pTlt"};